<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="410px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    :show-close="false"
  >
    <div class="dialog-container">
      <div class="close-btn" @click="handleClose">
        <i style="font-size: 30px; color: #ffffff" class="el-icon-close" />
      </div>

      <div class="expansion-red">
        <div class="tips">连续签到<span>{{ streakDays }}</span>天</div>
        <div class="daybox">
          <div
            class="dayitem"
            v-for="item in 7"
            :key="item"
            :style="{ flex: item === 7 ? '1' : '' }"
            :class="{ active: item <= streakDays }"
          >
            <div class="day">第{{ item }}天</div>
            <i class="el-icon-success icon"></i>
            <div class="price">+{{ dailyCredits[item - 1] || 0 }}</div>
          </div>
        </div>
        <div class="tips">
          连续签到7天可获得<span style="font-size: 14px">{{ totalWeekCredits }}</span>积分
        </div>
        <div class="btn" :class="{ disabel: claimed }" @click="handleClaim">
          {{ claimed ? '今日已签到' : '点击签到' }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { fetchSigninStatus, claimSignin } from "@/services/signin";

export default {
  name: "CheckDialog",
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      claimed: false,
      streakDays: 0,
      dailyCredits: [10, 10, 15, 15, 20, 20, 50],
      todayCredits: 10,
      loading: false,
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(v) { this.$emit("update:visible", v); },
    },
    totalWeekCredits() {
      return this.dailyCredits.reduce((sum, v) => sum + v, 0);
    },
  },
  watch: {
    visible(val) {
      if (val) this.loadStatus();
    },
  },
  methods: {
    async loadStatus() {
      try {
        const status = await fetchSigninStatus();
        if (!status) return;
        this.claimed = !!status.claimed;
        this.streakDays = status.streak_days || 0;
        if (Array.isArray(status.daily_credits) && status.daily_credits.length === 7) {
          this.dailyCredits = status.daily_credits;
        }
        if (status.today_credits > 0) {
          this.todayCredits = status.today_credits;
        }
      } catch (_) { /* ignore */ }
    },
    async handleClaim() {
      if (this.claimed || this.loading) return;
      this.loading = true;
      try {
        await claimSignin();
        this.claimed = true;
        this.streakDays = Math.min(7, this.streakDays + 1);
        this.$message.success(`签到成功，获得 ${this.todayCredits} 积分`);
      } catch (e) {
        const msg = (e && e.message) || "签到失败";
        if (msg.includes("already") || msg.includes("已")) {
          this.claimed = true;
        }
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .el-dialog {
  border-radius: 12px !important;
  background: transparent;
  box-shadow: none;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
.dialog-container {
  position: relative;
}
.close-btn {
  position: absolute;
  top: 20px;
  right: 0;
  cursor: pointer;
}
.btn {
  height: 46px;
  background: linear-gradient(96deg, #ff8514 0%, #ffa803 100%);
  box-shadow: 0px 10px 24px 0px rgba(255, 132, 0, 0.4);
  border-radius: 23px;
  margin: 0 auto;
  color: #ffffff;
  font-size: 16px;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  &.disabel {
    background: #eeeeee;
    color: #999999;
    box-shadow: none;
    cursor: default;
  }
}
.expansion-red {
  width: 410px;
  height: 540px;
  padding: 116px 70px 0;
  background-image: url("@/assets/image/checkBg.png");
  background-size: 100% 100%;
  .daybox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    .dayitem {
      width: 60px;
      height: 90px;
      padding: 10px 0;
      background-color: #ffffff;
      box-shadow: 0px 6px 16px 0px rgba(255, 126, 0, 0.2);
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      font-size: 14px;
      cursor: pointer;
      &.active {
        box-shadow: 0px 6px 16px 0px rgba(255, 126, 0, 0.7);
        border: solid 1px #ff8432;
        .day { color: #666666; }
        .icon { color: #ff8432; }
      }
      .day { color: #cccccc; }
      .price { color: #ff6e2e; }
      .icon { color: #ffd5b6; font-size: 24px; }
    }
  }
  .tips {
    font-size: 14px;
    color: #999999;
    text-align: center;
    span {
      font-size: 36px;
      color: #ff7d1d;
      display: inline-block;
      margin: 24px 10px;
      font-weight: 600;
    }
  }
}
</style>
